import { Box, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { CurrencyJSON } from "../../../../common/const";

const Cell = styled(TableCell)(({ theme }) => ({
    padding: '10px 0px 10px 20px',
}));

const AdditionDeductionTable = ({
    projectData,
    budget,
    tax,
    totalTax
}) => {
    const { additions, deductions } = projectData;
    const calculateValue = (item, totalBudget) => {
        if (!item?.approved) return 0;
        const { type, value } = item.approved;
        if (type === 'rate') {
            return parseFloat((value * totalBudget / 100)).toFixed(2);
        }
        return parseFloat(value).toFixed(2);
    };

    const appObj = {
        equipment: projectData?.approved_equipment_cost || 0,
        discount: calculateValue(deductions?.discount, projectData?.total_approved_budget),
        reuse: calculateValue(deductions?.reuse, projectData?.total_approved_budget),
        tax: calculateValue(additions?.tax, projectData?.total_approved_budget),
        installation: calculateValue(additions?.installation, projectData?.total_approved_budget),
        storage: calculateValue(additions?.storage, projectData?.total_approved_budget),
        fees: calculateValue(additions?.fees, projectData?.total_approved_budget),
        freight: calculateValue(additions?.freight, projectData?.total_approved_budget),
        contingency: calculateValue(additions?.contingency, projectData?.total_approved_budget),
        inflation: calculateValue(additions?.inflation, projectData?.total_approved_budget)
    };

    const getValue = (item, budget, label) => {
        if (!item?.actual) return 0;

        const { scope, type, value } = item.actual;
        const val = scope ? Number(scope === 'project' ? value : Number(budget[label])) : value;

        if (type === 'rate') {
            return ((Number(budget?.total_cost) || 0) * val) / 100;
        }

        return val;
    };

    const calculateDeduction = (item, budget, label) => {
        const value = getValue(item, budget, label);
        return value;
    };

    const calculateAddition = (item, budget, label) => {
        const baseValue = getValue(item, budget, label);
        return baseValue
    };

    const actualObj = {
        equipment: parseFloat(budget?.total_cost || 0).toFixed(2),
        discount: calculateDeduction(deductions?.discount, budget, 'total_discounts'),
        reuse: calculateDeduction(deductions?.reuse, budget, 'total_tradein'),
        installation: calculateAddition(additions?.installation,budget, 'total_installation'),
        contingency: calculateAddition(additions?.contingency, budget, 'Contingency'),
        inflation: calculateAddition(additions?.inflation, budget, 'Inflation'),
        storage: calculateAddition(additions?.storage, budget, 'total_storage'),
        fees: calculateAddition(additions?.fees, budget, 'total_fees'),
        freight: calculateAddition(additions?.freight, budget, 'total_freight'),
    }

    return (
        <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
            <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                    <TableHead>
                        <TableRow>
                            <Cell>Category</Cell>
                            <Cell>Approved</Cell>
                            <Cell>Actual</Cell>
                            <Cell>Variance</Cell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow sx={{ background: 'lightgray' }}>
                            <Cell sx={{ fontWeight: 'bold' }}>
                                Equipment
                            </Cell>
                            <Cell />
                            <Cell />
                            <Cell />
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Equipment
                            </Cell>
                            <Cell>
                                {`(${((appObj?.equipment * 100) / projectData?.total_approved_budget)} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.equipment).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${actualObj?.equipment}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.equipment - actualObj?.equipment).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow sx={{ background: 'lightgray' }}>
                            <Cell sx={{ fontWeight: 'bold' }}>
                                Deductions
                            </Cell>
                            <Cell />
                            <Cell />
                            <Cell />
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Discounts
                            </Cell>
                            <Cell>
                                {deductions?.discount?.approved?.type === 'rate' ?
                                    `(${deductions?.discount?.approved?.value ? deductions?.discount?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.discount}`
                                    : `(${((deductions?.discount?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.discount}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.discount).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.discount - actualObj.discount).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Trade In
                            </Cell>
                            <Cell>
                                {deductions?.reuse?.approved?.type === 'rate' ?
                                    `(${deductions?.reuse?.approved?.value ? deductions?.reuse?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.reuse}`
                                    : `(${((deductions?.reuse?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.reuse}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.reuse).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.reuse - actualObj?.reuse).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow sx={{ background: 'lightgray' }}>
                            <Cell sx={{ fontWeight: 'bold' }}>
                                Additions
                            </Cell>
                            <Cell />
                            <Cell />
                            <Cell />
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Tax
                            </Cell>
                            <Cell>
                                {additions?.tax?.approved?.type === 'rate' ?
                                    `(${additions?.tax?.approved?.value ? additions?.tax?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.tax}`
                                    : `(${((additions?.tax?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.tax}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(tax).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.tax - tax).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Installation
                            </Cell>
                            <Cell>
                                {additions?.installation?.approved?.type === 'rate' ?
                                    `(${additions?.installation?.approved?.value ? additions?.installation?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.installation}`
                                    : `(${((additions?.installation?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.installation}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.installation).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.installation - actualObj?.installation).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Storage
                            </Cell>
                            <Cell>
                                {additions?.storage?.approved?.type === 'rate' ?
                                    `(${additions?.storage?.approved?.value ? additions?.storage?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.storage}`
                                    : `(${((additions?.storage?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.storage}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.storage).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.storage - actualObj?.storage).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Freight
                            </Cell>
                            <Cell>
                                {additions?.freight?.approved?.type === 'rate' ?
                                    `(${additions?.freight?.approved?.value ? additions?.freight?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.freight}`
                                    : `(${((additions?.freight?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.freight}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.freight).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.freight - actualObj?.freight).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Fees
                            </Cell>
                            <Cell>
                                {additions?.fees?.approved?.type === 'rate' ?
                                    `(${additions?.fees?.approved?.value ? additions?.fees?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.fees}`
                                    : `(${((additions?.fees?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj.fees}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.fees).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.fees - actualObj?.fees).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Contingency
                            </Cell>
                            <Cell>
                                {additions?.contingency?.approved?.type === 'rate' ?
                                    `(${additions?.contingency?.approved?.value ? additions?.contingency?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.contingency}`
                                    : `(${((additions?.contingency?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.contingency}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.contingency).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.contingency - actualObj?.contingency).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow>
                            <Cell>
                                Inflation
                            </Cell>
                            <Cell>
                                {additions?.inflation?.approved?.type === 'rate' ?
                                    `(${additions?.inflation?.approved?.value ? additions?.inflation?.approved?.value : 0} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.inflation}`
                                    : `(${((additions?.inflation?.approved?.value * 100)) / projectData?.total_approved_budget} %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${appObj?.inflation}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(actualObj?.inflation).toFixed(2)}`}
                            </Cell>
                            <Cell>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(appObj?.inflation - actualObj?.inflation).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                        <TableRow sx={{ background: 'black' }}>
                            <Cell sx={{ color: 'white' }}>
                                Total
                            </Cell>
                            <Cell sx={{ color: 'white' }}>
                                {`(100 %) ${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(projectData?.total_approved_budget).toFixed(2)}`}
                            </Cell>
                            <Cell sx={{ color: 'white' }}>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(totalTax + budget?.total_cost).toFixed(2)}`}
                            </Cell>
                            <Cell sx={{ color: 'white' }}>
                                {`${CurrencyJSON.find((a) => a.value === projectData.currency)?.symbol} ${parseFloat(projectData?.total_approved_budget - (totalTax + budget?.total_cost)).toFixed(2)}`}
                            </Cell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default AdditionDeductionTable;